import { TimeSlot } from "@/generated/openapi";
import { CalendarDay } from "@/models/Calendar";
import { DateTime } from "luxon";
import { withDay } from "./dateTimeUtils";

const TIMESLOT_NOT_OPEN = 'timeslot_not_open'

function createPlaceholderDay(): CalendarDay {
  return {
    timeSlots: []
  }
}

function addPlaceholders(days: CalendarDay[], amount: number) {
  for(let i = 0; i < amount; i++) {
    days.push(createPlaceholderDay())
  }
}

function isSameDay(date1: DateTime, date2: DateTime) {
  return date1.hasSame(date2, 'year') && date1.hasSame(date2, 'month') && date1.hasSame(date2, 'day')
}

function addCalendarDays(days: CalendarDay[], timeSlots: TimeSlot[], fromDate: DateTime, toDate: DateTime) {
  let day = fromDate
  const dayAfterToDate = toDate.plus({ days: 1})
  while(!isSameDay(day, dayAfterToDate)) {
    const currentDay: CalendarDay = {
      dayOfMonth: day.day,
      timeSlots: timeSlots.filter(timeSlot => timeSlot.date === day.toISODate())
    }
    days.push(currentDay)
    day = day.plus({ days: 1})
  }
}

function filterTimeslotsNotOpen(calendarDays: CalendarDay[]): CalendarDay[] {
  return calendarDays.map(calendarDay => {
    calendarDay.timeSlots = calendarDay.timeSlots.filter(timeslot => {
      if (timeslot.capacity === 0) {
        return false
      }
      if (timeslot.failedRules && Array.from(timeslot.failedRules).includes(TIMESLOT_NOT_OPEN)) {
        return false
      }
      return true
    })
    return calendarDay
  })
}

function asDays(timeSlots: TimeSlot[], dateTime: DateTime): CalendarDay[] {
  const days: CalendarDay[] = []
  const firstDayInMonth = withDay(dateTime, 1)
  const lastDayInMonth = withDay(dateTime, dateTime.daysInMonth)
  addPlaceholders(days, firstDayInMonth.weekday - 1)
  addCalendarDays(days, timeSlots, firstDayInMonth, lastDayInMonth)
  addPlaceholders(days, 7 - lastDayInMonth.weekday)
  return days
}

export {
  asDays,
  filterTimeslotsNotOpen
}
